import type { IWarehouseApi } from "../../../api/WarehouseApi";
import { Action } from "../../../types/entities";

interface DeleteProductWithJournalOptions {
  api: IWarehouseApi;
  productId: string;
  sourceBoxId: string | null | undefined;
  deleteReason?: string | null;
  sourceLabel: string;
}

export function normalizeDeleteReason(
  deleteReason?: string | null,
): string | null {
  const normalized = (deleteReason || "").trim();
  return normalized || null;
}

function buildDestroyComment(
  sourceLabel: string,
  normalizedReason: string | null,
): string {
  if (normalizedReason) {
    return `Удалено ${sourceLabel}. Причина: ${normalizedReason}`;
  }

  return `Удалено ${sourceLabel}`;
}

export async function deleteProductWithDestroyJournal(
  options: DeleteProductWithJournalOptions,
): Promise<void> {
  const normalizedReason = normalizeDeleteReason(options.deleteReason);
  const sourceBoxId = (options.sourceBoxId || "").trim();

  if (sourceBoxId) {
    await options.api.createJournalEntry({
      action: Action.destroy,
      productId: options.productId,
      fromTo: sourceBoxId,
      value: 1,
      comment: buildDestroyComment(options.sourceLabel, normalizedReason),
    });
  }

  await options.api.deleteProduct(options.productId, normalizedReason);
}
